// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-upload {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.upload-header {
  text-align: center;
  margin-bottom: 30px;
}

.upload-header h2 {
  color: #333;
  margin-bottom: 10px;
}

.upload-header p {
  color: #666;
  font-size: 16px;
}

.upload-form {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* File Upload Area */
.file-upload-area {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  transition: all 0.3s ease;
  background-color: #fafafa;
  cursor: pointer;
}

.file-upload-area.drag-active {
  border-color: #007bff;
  background-color: #f0f8ff;
  transform: scale(1.02);
}

.file-upload-area.has-file {
  border-color: #28a745;
  background-color: #f8fff9;
}

.upload-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.upload-icon {
  font-size: 48px;
  opacity: 0.6;
}

.upload-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.upload-text p {
  margin: 0;
  color: #333;
}

.browse-button {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.browse-button:hover {
  background: #0056b3;
}

.file-types {
  font-size: 12px;
  color: #888;
  margin-top: 10px;
}

/* Selected File Display */
.selected-file {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 15px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.file-icon {
  font-size: 32px;
}

.file-info {
  flex: 1 1;
  text-align: left;
}

.file-name {
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.file-size {
  font-size: 12px;
  color: #666;
}

.remove-file {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.remove-file:hover {
  background: #c82333;
}

/* Form Fields */
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group select {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-group input.auto-filled {
  background-color: #f8f9fa;
  border-color: #28a745;
  color: #495057;
}

.field-note {
  font-size: 12px;
  color: #28a745;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Error and Success Messages */
.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  color: #721c24;
}

.localhost-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 4px;
  color: #0c5460;
}

.no-n8n-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 4px;
  color: #0c5460;
}

.error-icon {
  font-size: 16px;
}

.upload-result {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
}

.upload-result.success {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.upload-result.error {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.result-icon {
  font-size: 16px;
  margin-top: 2px;
}

.result-message {
  flex: 1 1;
}

.result-details {
  font-size: 12px;
  margin-top: 5px;
  opacity: 0.8;
}

/* Info sections within upload result */
.localhost-info,
.no-n8n-info {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.4;
}

.info-icon,
.warning-icon {
  font-size: 16px;
  flex-shrink: 0;
}

/* Navigation info section */
.navigation-info {
  margin-top: 10px;
  padding: 12px;
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 4px;
  color: #1565c0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.view-reviews-btn {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease;
  margin-left: auto;
}

.view-reviews-btn:hover {
  background-color: #0056b3;
}

/* Submit Button */
.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.submit-button {
  background: #28a745;
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.submit-button:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
}

.submit-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.65;
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .document-upload {
    margin: 10px;
    padding: 15px;
  }
  
  .file-upload-area {
    padding: 30px 15px;
  }
  
  .upload-icon {
    font-size: 36px;
  }
  
  .selected-file {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }
  
  .file-info {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DocumentUpload.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,uCAAuC;AACvC;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".document-upload {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.upload-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.upload-header h2 {\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.upload-header p {\n  color: #666;\n  font-size: 16px;\n}\n\n.upload-form {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n/* File Upload Area */\n.file-upload-area {\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  padding: 40px 20px;\n  text-align: center;\n  transition: all 0.3s ease;\n  background-color: #fafafa;\n  cursor: pointer;\n}\n\n.file-upload-area.drag-active {\n  border-color: #007bff;\n  background-color: #f0f8ff;\n  transform: scale(1.02);\n}\n\n.file-upload-area.has-file {\n  border-color: #28a745;\n  background-color: #f8fff9;\n}\n\n.upload-prompt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.upload-icon {\n  font-size: 48px;\n  opacity: 0.6;\n}\n\n.upload-text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.upload-text p {\n  margin: 0;\n  color: #333;\n}\n\n.browse-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s ease;\n}\n\n.browse-button:hover {\n  background: #0056b3;\n}\n\n.file-types {\n  font-size: 12px;\n  color: #888;\n  margin-top: 10px;\n}\n\n/* Selected File Display */\n.selected-file {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  padding: 15px;\n  background: white;\n  border-radius: 6px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.file-icon {\n  font-size: 32px;\n}\n\n.file-info {\n  flex: 1;\n  text-align: left;\n}\n\n.file-name {\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.file-size {\n  font-size: 12px;\n  color: #666;\n}\n\n.remove-file {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.remove-file:hover {\n  background: #c82333;\n}\n\n/* Form Fields */\n.form-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: bold;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.form-group input.auto-filled {\n  background-color: #f8f9fa;\n  border-color: #28a745;\n  color: #495057;\n}\n\n.field-note {\n  font-size: 12px;\n  color: #28a745;\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Error and Success Messages */\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  color: #721c24;\n}\n\n.localhost-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  background: #d1ecf1;\n  border: 1px solid #bee5eb;\n  border-radius: 4px;\n  color: #0c5460;\n}\n\n.no-n8n-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  background: #d1ecf1;\n  border: 1px solid #bee5eb;\n  border-radius: 4px;\n  color: #0c5460;\n}\n\n.error-icon {\n  font-size: 16px;\n}\n\n.upload-result {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 15px;\n}\n\n.upload-result.success {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.upload-result.error {\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.result-icon {\n  font-size: 16px;\n  margin-top: 2px;\n}\n\n.result-message {\n  flex: 1;\n}\n\n.result-details {\n  font-size: 12px;\n  margin-top: 5px;\n  opacity: 0.8;\n}\n\n/* Info sections within upload result */\n.localhost-info,\n.no-n8n-info {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.info-icon,\n.warning-icon {\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n/* Navigation info section */\n.navigation-info {\n  margin-top: 10px;\n  padding: 12px;\n  background: #e3f2fd;\n  border: 1px solid #bbdefb;\n  border-radius: 4px;\n  color: #1565c0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n}\n\n.view-reviews-btn {\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease;\n  margin-left: auto;\n}\n\n.view-reviews-btn:hover {\n  background-color: #0056b3;\n}\n\n/* Submit Button */\n.form-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.submit-button {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 15px 30px;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.submit-button:hover:not(:disabled) {\n  background: #218838;\n  transform: translateY(-1px);\n}\n\n.submit-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .document-upload {\n    margin: 10px;\n    padding: 15px;\n  }\n  \n  .file-upload-area {\n    padding: 30px 15px;\n  }\n  \n  .upload-icon {\n    font-size: 36px;\n  }\n  \n  .selected-file {\n    flex-direction: column;\n    text-align: center;\n    gap: 10px;\n  }\n  \n  .file-info {\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
